module.exports = __webpack_public_path__ + "ffd1d4c86b1b803dd4ff9687285334f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hun.svg
// module id = 56
// module chunks = 0